import { Flex, Avatar, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { ListViewContainer } from "./styles";

interface ListViewItemProps {
  title: string;
  description?: string;
  image?: string;
  right?: string;
  bordered?: boolean;
}

function ListViewItem(props: ListViewItemProps) {
  return (
    <ListViewContainer
      bg="white"
      rounded="8px"
      borderBottomWidth={props.bordered ? 1 : 0}
      borderBottomColor={colors.black300}
      p={4}
      alignItems="center"
      gap="16px"
    >
      <Flex className="hidden-print">
        <Avatar
          name={props.title}
          src={props.image || undefined}
          w="45px"
          h="45px"
        />
      </Flex>
      <Flex className="center-container" flex={1} flexDir="column">
        <Text color={colors.black} fontWeight="bold">
          {props.title}
        </Text>

        {props.description ? (
          <Text fontSize="12px" p="0px" color={colors.black700}>
            {props.description}
          </Text>
        ) : null}
      </Flex>

      {props.right ? (
        <Flex className="right-container">
          <Text fontWeight="bold">{props.right}</Text>
        </Flex>
      ) : null}
    </ListViewContainer>
  );
}

export default ListViewItem;
